<template>
  <div class="bbp-table-date" :class="['bbp-table-date_' + highlightClassName]">
    {{value}}
  </div>
</template>

<script>
import {get} from 'lodash'
import moment from 'moment'

export default {
  name: 'BBPDateCell',
  props: ['row', 'column', 'index'],
  computed: {
    value () {
      const date = get(this.row, this.column.prop, '')
      return this.formatDate(date)
    },
    highlightClassName () {
      if (!this.column.highlightPast) return ''
      const date = get(this.row, this.column.prop, '')
      const today = moment().isSame(date, 'day')
      const isAfter = moment().isAfter(date, 'day')
      if (today) {
        return 'today'
      } else if (isAfter) {
        return 'past'
      }
    }
  },
  methods: {
    formatDate (date) {
      const momentDate = moment(date)
      const isValid = momentDate.isValid()
      return isValid ? momentDate.format('DD-MMM-YY') : ''
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../sass/variables";
  @import "../../../../sass/mixins";

  .bbp-table-date {
    @include global-font;
    display: inline-block;
    padding: 7px 8px;
    margin-left: -8px;
    border-radius: 3px;
    font-weight: normal;
    font-size: 13px;
    line-height: 16px;

    &_today {
      color: $color-la-rioja;
      background: rgba($color-la-rioja, 0.2)
    }

    &_past {
      color: $color-pomegranate;
      background: rgba($color-pomegranate, 0.2)
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Main/BBPTable/BBPDateCell/BBPDateCell.vue